
import { mapMutations, mapGetters } from "vuex";

export default {
    data () {
        return {
            form: {
                vat: '',
                invoice_email: '',
                contact_person: '',
            },
            success: false
        }
    },
    methods: {
        ...mapMutations('modal', ['closeModal']),
        async submit () {
            if (this.form.vat.length !== 8) {
                this.setToast({ msg: 'Indtast CVR på 8 cifre' });
                return;
            }
            if (!this.emailValid) {
                this.setToast({ msg: 'Indtast en gyldig faktura e-mail' });
                return;
            }

            const payload = this.form;
            try {
                const { data } = await this.$axios.post('/enable-invoice', payload);
                this.success = true;
                setTimeout(() => {
                    location.reload();
                }, 1000);
            }
            catch (err){
                this.setToast({ msg: 'Hov, noget gik galt. Prøv venligst igen' });
            }
        }
    },
    computed: {
        ...mapGetters(['loggedInUser']),
        validated () {
            if (this.form.vat.length !== 8) {
                return false;
            }
            if (!this.emailValid) {
                return false;
            }
            return true;
        },
        emailValid () {
            return this.form.invoice_email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        }
    }
}
